import constants from '../constants';

export const possibleToConnectProtocols = ['ssh', 'telnet'];

export const animations = {
  FASTEST: 300,
  FASTER: 500,
  FAST: 800,
  NORMAL: 1000,
  SLOW: 2000,
  SLOWER: 3000,
};

export const protocolsWithExistingLogs = ['ssh', 'telnet', 'api'];

export const decimalPlacesDefaults = {
  percentage: constants.percentageDecimalPlaces,
  promile: constants.promileDecimalPlaces,
  rate: constants.rateDecimalPlaces,
};
